import ajax from '@/utils/ajax';

export const head = '/web';

// 获取模考详情
export const getHomeDataApi = (data) => ajax(`${head}/v1/question-bank/exam/base-info?businessLine=${data.businessLine}&examId=${data.examId}`, '', 'GET');

// 获取任务列表
export const getTaskApi = (value) => ajax(`${head}/v1/lms/user-examination/learn-questionnaire?userProductId=${value}`, '', 'GET');

// 提交个人档案
export const subArchivesInfoApi = (data) => ajax(`${head}/v1/lms/user-examination/submit`, data, 'POST');

// 模糊搜索学校
export const getSchoolApi = (value) => ajax(`${head}/v1/academy/university/match?name=${value}&pageSize=50&pageNum=1`, '', 'GET');
// 模糊搜索专业
export const getSubjectApi = (value) => ajax(`${head}/v1/academy/major/match?name=${value}&pageSize=50&pageNum=1`, '', 'GET');
